function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import colors from "/styles/colors";
import { GenericConfigContext } from "/contexts/generic-config-context";
import { getBrandCtaColorName } from "/services/brand-service";
import { SECONDARY_BUTTON_CLICKED } from "/constants/bigbrain-event-types";
import { getAccessibleButtonColor } from "client/services/accessibility/accessibility-service";
import { DODGER_BLUE_COLOR_NAME, SPACE_BLUE_COLOR_NAME, ELEVATE_BUTTON_GRADIANT_COLOR_NAME, WHITE_COLOR_NAME } from "styles/color-consts";
import { withAbTests } from "contexts/ab-tests-context";
import { getLastPartOfUrl } from "utils/url";
import classnames from "classnames";
import RightArrow from "/static/svg/arrow-right-3.svg";
import { hexToRgba } from "utils/general";
import { getMondayUrl, isExistingAccount } from "services/monday-platform/existing-accounts-service";
import { trackEvent } from "services/bigbrain-service";
import DefaultProps from "./default-props";
import { StyledSecondaryButton } from "./secondary-button.scss";
import AssetComponent from "components/core/asset/asset-component";
const SecondaryButton = (props)=>{
    var _useContext;
    const { buttonText, url, isOpenLinkInNewTab, color, isWithArrow, iconRenderer, isWithIconInsteadOfArrow, withoutUnderline, onClick, platformUrl, ariaLabel, leftSideIcon } = props;
    const buttonUrl = platformUrl && isExistingAccount() ? getMondayUrl(platformUrl) : url;
    const onButtonClick = (e)=>{
        const isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
        trackEvent(SECONDARY_BUTTON_CLICKED, {
            kind: buttonText,
            info1: isKeyboardEvent ? "keyboard" : "mouse",
            info2: buttonUrl,
            info3: getLastPartOfUrl(buttonUrl)
        });
        if (onClick) {
            onClick(e);
        }
    };
    const getButtonColor = (accessibleColor)=>{
        if (accessibleColor === DODGER_BLUE_COLOR_NAME) return SPACE_BLUE_COLOR_NAME;
        if (accessibleColor === ELEVATE_BUTTON_GRADIANT_COLOR_NAME) return WHITE_COLOR_NAME;
        return accessibleColor;
    };
    // Purple text and arrow turn black on the new brand; nothing changes off-brand.
    const isNewBrand = (_useContext = useContext(GenericConfigContext)) === null || _useContext === void 0 ? void 0 : _useContext.isNewBrand;
    const accessibleColor = getAccessibleButtonColor(getBrandCtaColorName(color, isNewBrand));
    const finalColor = getButtonColor(accessibleColor);
    const showIcon = iconRenderer && !isWithIconInsteadOfArrow;
    const showArrow = isWithArrow && !isWithIconInsteadOfArrow;
    const showIconInsteadOfArrow = isWithIconInsteadOfArrow && iconRenderer;
    let aProps = {
        style: {
            color: colors[finalColor],
            "--underline-color": colors[finalColor],
            "--underline-color-with-opacity": hexToRgba(colors[finalColor], 0.4)
        }
    };
    if (buttonUrl) {
        aProps = _object_spread_props(_object_spread({}, aProps), {
            href: buttonUrl,
            target: isOpenLinkInNewTab ? "_blank" : "_self"
        });
    }
    return /*#__PURE__*/ _jsxs(StyledSecondaryButton, {
        className: "secondary-button",
        children: [
            leftSideIcon && /*#__PURE__*/ _jsx("span", {
                className: "left-side-icon",
                children: /*#__PURE__*/ _jsx(AssetComponent, {
                    image: {
                        src: leftSideIcon === null || leftSideIcon === void 0 ? void 0 : leftSideIcon.src
                    },
                    width: leftSideIcon === null || leftSideIcon === void 0 ? void 0 : leftSideIcon.size
                })
            }),
            /*#__PURE__*/ _jsxs("a", _object_spread_props(_object_spread({}, aProps), {
                onClick: onButtonClick,
                "aria-label": ariaLabel,
                className: classnames({
                    "with-icon": iconRenderer,
                    "with-icon-instead-of-arrow": showIconInsteadOfArrow,
                    "with-underline": !withoutUnderline
                }),
                children: [
                    showIcon && iconRenderer(),
                    /*#__PURE__*/ _jsx("span", {
                        className: "secondary-button-text",
                        children: buttonText
                    }),
                    showArrow && /*#__PURE__*/ _jsx("span", {
                        className: "arrow-wrapper",
                        children: /*#__PURE__*/ _jsx(RightArrow, {})
                    }),
                    showIconInsteadOfArrow && /*#__PURE__*/ _jsx("span", {
                        className: "icon-instead-of-arrow-wrapper",
                        children: iconRenderer()
                    })
                ]
            }))
        ]
    });
};
SecondaryButton.defaultProps = DefaultProps;
export default withAbTests(SecondaryButton);
